import { Injectable } from '@angular/core';
import { RelayParameters } from '../../domain/relay-parameters';
import { RelaySummary } from '../../domain/relay-summary';
import { RelayRepository } from '../../relay.repository';
import { FormViewModel } from './form.view.model';
import { RelayCard } from '../../domain/relay-cards.model';

@Injectable()
export class FormPresenter {
  constructor(private relayRepository: RelayRepository) {}

  load(callback): void {
    let vm: FormViewModel;
    this.relayRepository.getCurrentCard((relayCard: RelayCard) => {
      const formValid = relayCard?.helpForm ? relayCard.helpForm.valid : false;
      vm = {
        useBranding: relayCard?.useBranding,
        hostOwnsBranding: relayCard?.hostOwnsBranding ?? false,
        i18nKeys: relayCard?.i18nKeys,
        customStyle: relayCard?.customStyle,
        customFont: relayCard?.customFont,
        readOnly: false,
        demo: false,
        state: 'inline',
        form: relayCard?.form,
        card: { ...relayCard?.card, stepProgress: `${relayCard?.card.step}/${relayCard?.card.total}` },
        wrapperClass: '',
        showClose: false,
        helpEnabled: relayCard?.helpEnabled,
        helpForm: relayCard?.helpForm,
        helpButtonDisplayed:
          relayCard?.flagProjectFeatureFlagEnabled &&
          !relayCard?.helpRequestInProgress &&
          !this.isSummaryCard(relayCard),
        helpRequestSubmitted: relayCard?.helpRequestSubmitted,
        helpRequestButtonDisabled: !formValid || relayCard?.helpRequestInProgress,
        helpRequestInProgress: relayCard?.helpRequestInProgress,
        helpCancelActionText: relayCard?.helpRequestSubmitted ? relayCard?.i18nKeys?.back : relayCard?.i18nKeys?.cancel,
        helpMessages: { required: relayCard?.i18nKeys?.required, email: relayCard?.i18nKeys?.help?.invalidEmail },
        helpLabel: relayCard?.i18nKeys?.help?.label,
        helpTitle: relayCard?.i18nKeys?.help?.title,
        helpSubmitLabel: relayCard?.i18nKeys?.help?.submitLabel,
        helpPreSubmitMessage: relayCard?.i18nKeys?.help?.preSubmitMessage,
        helpPostSubmitMessage: relayCard?.i18nKeys?.help?.postSubmitMessage,
        helpFirstNameFormLabel: relayCard?.i18nKeys?.help?.firstName,
        helpLastNameFormLabel: relayCard?.i18nKeys?.help?.lastName,
        helpEmailFormLabel: relayCard?.i18nKeys?.help?.email,
        helpPhoneNumberFormLabel: relayCard?.i18nKeys?.help?.phoneNumber,
        helpCommentFormLabel: relayCard?.i18nKeys?.help?.comment,
        qaHelpForm: 'help-form',
        qaFirstNameInput: 'help-form_firstName',
        qaLastNameInput: 'help-form_lastName',
        qaEmailInput: 'help-form_email',
        qaPhoneNumberInput: 'help-form_phoneNumber',
        qaCommentInput: 'help-form_comment',
        qaCancelButton: 'help-form_cancel',
        qaSubmitButton: 'help-form_submit'
      };
      this.relayRepository.getSummary((summary: RelaySummary) => {
        if (!summary) {
          return;
        }
        vm.total = summary.total;
        vm.step = summary.step;
        vm.complete = summary.step > summary.total;
        callback(vm);
      });
    });
  }

  private isSummaryCard(card: RelayCard): boolean {
    return !card.hasNext && !card.hasPrevious;
  }

  requestHelp() {
    this.relayRepository.requestHelp(true);
  }

  cancelHelp() {
    this.relayRepository.requestHelp(false);
  }

  async submitHelp() {
    await this.relayRepository.submitHelp();
  }

  setParameters(parameters: RelayParameters) {
    this.relayRepository.subscribeToParameters();
    this.relayRepository.setParameters(parameters);
  }

  cleanup() {
    this.relayRepository.unsubscribe();
  }
}
